import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './MohiniChatbot.css';

const DEFAULT_CHAT_URL = 'https://chat.bsbinfotrade.com';

/** Assistant mark (not WhatsApp) — crisp on the blue FAB */
function MohiniAssistantIcon() {
  return (
    <svg
      className="mohini-chatbot__fab-svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M12 3C7.58 3 4 6.36 4 10.5c0 2.07.94 3.93 2.44 5.23L5 21l5.62-2.06A7.41 7.41 0 0012 18c4.42 0 8-3.36 8-7.5S16.42 3 12 3Z"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinejoin="round"
        fill="rgba(255,255,255,0.12)"
      />
      <circle cx="9" cy="10.5" r="1.1" fill="currentColor" />
      <circle cx="12" cy="10.5" r="1.1" fill="currentColor" />
      <circle cx="15" cy="10.5" r="1.1" fill="currentColor" />
      <path
        d="M17 4.5l.35.85.9.2-.9.6-.35.95-.5-.85-1 .35.6-.9-.85-.5.95-.35Z"
        fill="currentColor"
        opacity="0.9"
      />
    </svg>
  );
}

function MohiniChatbot() {
  const baseChatUrl = process.env.REACT_APP_MOHINI_CHAT_URL || DEFAULT_CHAT_URL;
  // Force a fresh chatbot session on every full page load / revisit.
  const chatUrl = useMemo(() => {
    const url = new URL(baseChatUrl);
    url.searchParams.set('embed_session', `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
    return url.toString();
  }, [baseChatUrl]);
  const [open, setOpen] = useState(false);
  const [shouldMountIframe, setShouldMountIframe] = useState(false);

  useEffect(() => {
    const links = [];
    const origins = ['https://chat.bsbinfotrade.com', 'https://api.bsbinfotrade.com'];

    origins.forEach((origin) => {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = origin;
      preconnect.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect);
      links.push(preconnect);

      const dnsPrefetch = document.createElement('link');
      dnsPrefetch.rel = 'dns-prefetch';
      dnsPrefetch.href = origin;
      document.head.appendChild(dnsPrefetch);
      links.push(dnsPrefetch);
    });

    return () => {
      links.forEach((link) => link.remove());
    };
  }, []);

  const toggle = useCallback(() => {
    setShouldMountIframe(true);
    setOpen((v) => !v);
  }, []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <div className="mohini-chatbot">
      {shouldMountIframe && (
        <div
          id="mohini-chatbot-panel"
          className={`mohini-chatbot__panel${open ? '' : ' mohini-chatbot__panel--hidden'}`}
          role="dialog"
          aria-modal="false"
          aria-label="Mohini — BSB Assistant"
        >
          <div className="mohini-chatbot__toolbar">
            <span className="mohini-chatbot__title">Mohini — BSB Assistant</span>
            <button
              type="button"
              className="mohini-chatbot__toolbar-close"
              onClick={close}
              aria-label="Close chat"
            >
              <i className="fa-solid fa-xmark" aria-hidden />
            </button>
          </div>
          <iframe
            src={chatUrl}
            title="Mohini - BSB Assistant"
            allow="microphone"
            className="mohini-chatbot__iframe"
            loading="eager"
          />
        </div>
      )}
      <button
        type="button"
        className="mohini-chatbot__fab"
        onClick={toggle}
        aria-expanded={open}
        aria-controls="mohini-chatbot-panel"
        aria-label={open ? 'Close Mohini assistant' : 'Open Mohini assistant chat'}
      >
        {open ? (
          <i className="fa-solid fa-xmark mohini-chatbot__fab-icon" aria-hidden />
        ) : (
          <MohiniAssistantIcon />
        )}
      </button>
    </div>
  );
}

export default MohiniChatbot;
